import { assertNever } from '@kofno/piper';
import { observer } from 'mobx-react';
import * as React from 'react';
import Loader from '../../../Loader';
import LoadError from '../LoadError';
import LearningCollectionStore from '../Store';
import Builder from './Builder';
import ChooseProductLicense from './ChooseProductLicense';
import Navigation from '../Edit/CurrentCollectionStep/Navigation';
import ReloadAllExperiences from './ReloadAllExperiences';

interface Props {
  store: LearningCollectionStore;
}

const CurrentCollectionStep: React.FC<Props> = ({ store }) => {
  switch (store.state.kind) {
    case 'waiting':
    case 'loading':
    case 'ready':
      return <Loader />;
    case 'reload-all-experiences':
      return <ReloadAllExperiences store={store} />;
    case 'choosing-product-license':
      return <ChooseProductLicense store={store} />;
    case 'building':
    case 'new-form-submission-error':
      return <Builder store={store} state={store.state} />;
    case 'load-error':
      return <LoadError />;
    case 'creating':
      return (
        <>
          <Navigation store={store} />
          <Loader />;
        </>
      );
    default:
      assertNever(store.state);
  }
};

export default observer(CurrentCollectionStep);
